import { z } from 'zod';
import { bankNameRegex, bankBranchNameRegex, bankAccountHolderNameRegex } from '../../../../libs/utils/bank-account-regex';

export const basicInfoSchema = z.object({
  name: z.string().min(1, '事業者名を入力してください').default(''),
  ownerName: z.string().min(1, '登録代表者名を入力してください').default(''),
  address: z.string().min(1, '住所を入力してください').default(''),
  contact: z.string().refine((val) =>
    /^0\d{9,10}$/.test(val),
    {
      message: "電話番号を0から始まる10-11桁の数字で入力してください",
    }
  ).default(''),
})

export const bankAccountInfoSchema = z.object({
  bankName: z.string().min(1, '銀行名を入力してください').refine((val) => {
    const regex = bankNameRegex;
    return regex.test(val);
  }, {
    message: "銀行名はカナで入力してください（漢字は使用できません。例: ミズホ）",
  }).default(''),
  bankCode: z.string().refine((val) =>
    /^\d{4}$/.test(val),
    {
      message: "金融機関コードを4桁の数字で入力してください",
    }
  ).default(''),
  bankBranchName: z.string().min(1, '支店名を入力してください').refine((val) => {
    const regex = bankBranchNameRegex;
    return regex.test(val);
  }, {
    message: "支店名はカナで入力してください（漢字は使用できません。例: シンジュク）",
  }).default(''),
  bankBranchCode: z.string().refine((val) =>
    /^\d{3}$/.test(val),
    {
      message: "支店コードを3桁の数字で入力してください",
    }
  ).default(''),
  bankAccountType: z.enum(['普通', '当座']).default('普通'),
  bankAccountNumber: z.string().refine((val) =>
    /^\d{1,7}$/.test(val),
    {
      message: "口座番号を入力してください",
    }
  ).default(''),
  bankAccountHolderName: z.string().min(
    1, '口座名義を入力してください'
  ).refine((val) => {
    const regex = bankAccountHolderNameRegex;
    return regex.test(val);
  }, {
    message: "口座名義はカナで入力してください（漢字は使用できません。例: ヤマダタロウ）",
  }).default(''),
})

export const companyInfoSchema = basicInfoSchema.merge(bankAccountInfoSchema)

export const companyInfoCsvRowSchema = basicInfoSchema.extend({
  companyId: z.string().default('').optional(),
})